import { BaseProduct } from 'src/components/ProductDetail/utils/product-detail.types';
import { fireGtm } from 'src/features/analytics/hooks/useGtm';
import { getCurrencyCode, getStoreName, trackAddedToCart } from 'src/features/klaviyo/klaviyo.utils';
import { ProductPrice } from 'src/types/global-types';
import Bugsnag from '@bugsnag/js';

type AddToCartTrackingDetails = {
    price?: ProductPrice | null;
    quantity?: number;
    currency?: string;
};

export const gtmAddToCartWithVersion = (
    event: string,
    product: BaseProduct,
    redirectUrl?: string,
    trackingDetails: AddToCartTrackingDetails = {},
) => {
    try {
        const categories = product.categories?.map((cat) => cat.name) || [];
        const imageUrl = product.small_image || product.media_entries?.[0]?.large_url;
        const price = trackingDetails.price?.price;
        const compareAtPrice =
            trackingDetails.price && trackingDetails.price.regular_price > trackingDetails.price.price
                ? trackingDetails.price.regular_price
                : undefined;
        const quantity = trackingDetails.quantity || 1;
        const value = price ? price * quantity : undefined;
        const productUrl =
            typeof window !== 'undefined' ? window.location.href : product.url_key ? `/${product.url_key}` : undefined;

        trackAddedToCart({
            ProductName: product.name,
            ProductID: product.id,
            SKU: product.sku,
            Categories: categories,
            ImageURL: imageUrl,
            URL: productUrl,
            Brand: product.brand_badge || undefined,
            Price: price,
            CompareAtPrice: compareAtPrice,
            Quantity: quantity,
            Value: value,
            Store: getStoreName(),
            Currency: getCurrencyCode(trackingDetails.currency),
            ProductType: product.type,
            AddedItemProductName: product.name,
            AddedItemProductID: product.id,
            AddedItemSKU: product.sku,
            AddedItemCategories: categories,
            AddedItemImageURL: imageUrl,
            AddedItemURL: productUrl,
            AddedItemPrice: price,
            AddedItemQuantity: quantity,
            $value: value,
            CanCustomise: product.can_customise,
            DefaultCategory: product.default_category,
            DefaultCategoryURL: product.default_category_url,
            ProductTags: product.product_tags,
            ShippingType: product.shippingType,
            Is24HourDelivery: product.is_24_hour_delivery,
            Gender: product.gender,
            Material: product.material,
            BodyFit: product.filter_body_fit,
        });
    } catch (error) {
        Bugsnag.notify(error instanceof Error ? error : new Error(String(error)));
    }

    fireGtm({
        event,
        eecEventName: 'Add to Cart',
        ecommerce: {
            add: {
                actionField: {
                    list: '',
                },
                products: [
                    {
                        id: product.sku,
                        name: product.name,
                    },
                ],
            },
        },
        eventCallback: () => {
            if (redirectUrl) location.href = redirectUrl;
        },
    });
};
